import { Component, OnInit, Input } from '@angular/core';

/**
  Componente que muestra el estado de un pago.
  Este componente permite visualizar el estado de un pago (éxito, error, etc.) mediante
  un ícono y mensajes personalizables. También admite la visualización de un segundo mensaje
  y la posibilidad de mostrar un diseño específico para RB (Reembolso).
**/
@Component({
    selector: 'am-status-payment',
    templateUrl: './am-status-payment.component.html',
    styleUrls: ['./am-status-payment.component.scss'],
    standalone: false
})
export class AmStatusPaymentComponent implements OnInit {
    /**
    Tipo de estado del pago (ej. 'success', 'error', etc.).
    Determina el ícono y el estilo visual que se mostrará.
    @type {string}
    @default 'success'
  **/
    @Input() type = 'success';

    /**
      Título que se muestra en el componente.
      @type {string}
      @default '-----'
    **/
    @Input() title = '-----';
  
    /**
      Mensaje principal que se muestra en el componente.
      @type {string}
    **/
    @Input() message = '';
  
    /**
      Mensaje secundario que se muestra en el componente.
      @type {string}
    **/
    @Input() message2 = '';
  
    /**
      Indica si el componente debe usar un diseño específico para RB (Reembolso).
      @type {boolean}
      @default false
    **/
    @Input() isRb = false;
  
    /**
      Ruta de la imagen principal que se muestra según el tipo de estado.
      @type {string}
    **/
    url: string = '';
  
    /**
      Ruta de la imagen secundaria (ícono) que se muestra según el tipo de estado.
      @type {string}
    **/
    url2: string = '';
  constructor() { }
 /**
    Método del ciclo de vida de Angular que se ejecuta al inicializar el componente.
    Construye las rutas de las imágenes según el tipo de estado proporcionado.
    @return void
  **/
  ngOnInit(): void {
    this.url = 'assets/images/payment/payment-'+ this.type+'.svg'
    this.url2 = 'assets/images/payment/icon-'+ this.type+'.svg'
  }
}
